export const COPYRIGHT_TEXT = "Copyright ©  2026 Kenshin Systems. All rights reserved.";
